import { Body1, Header1 } from '@flatsy/core/MaterialUi/Typo'
import theme from '@flatsy/core/MuiTheme/theme'
import React, { useContext } from 'react'
import PhoneIcon from '@material-ui/icons/Phone'
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail'
import { toNameCase } from '@flatsy/core/MaterialUi/Typo/Utile'
import { formatPhoneNumber } from '@flatsy/utils/Functions/format/PhoneNumber'
import { APPLICANT_KIND } from '@flatsy/types/Applications/Applicant'
import { FileContext } from '../../../Context'
import { useStyles } from './Style'

const ApplicantInformation: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const {
    informationForm: { toggle },
    applicants: { current, list },
  } = useContext(FileContext)
  const handleShowForm = () => {
    toggle({
      open: true,
      userId: '',
    })
  }

  if (!current) {
    return <></>
  }

  const getApplicantName = (): string => {
    if (!current.first_name || current.first_name === '') {
      if (current.kind === APPLICANT_KIND.guarantor) {
        if (current.applicant_id && list) {
          const find = list.find((singleApplicant) => current.applicant_id === singleApplicant.id)
          if (find) {
            return `Garant de ${toNameCase(find.first_name)}`
          }
        }
        return 'Garant'
      }
      return 'Colocataire'
    }
    if (current.kind === APPLICANT_KIND.guarantor) {
      return `${toNameCase(current.first_name)} (garant)`
    }
    return `${toNameCase(current.first_name)} ${toNameCase(current.last_name)}`
  }

  const renderPhoneInformation = () => {
    if (!current.phone_number || current.phone_number === '') {
      return (
        <button type="button" className={classes.addInformationContainer} onClick={handleShowForm}>
          <PhoneIcon className={classes.icon} />
          <Body1 fontColor={theme.palette.primary.main}>ajouter un téléphone</Body1>
        </button>
      )
    }
    return (
      <div className={classes.informationContainer}>
        <PhoneIcon className={classes.icon} />
        <Body1 fontColor={theme.palette.secondary.dark}>
          {formatPhoneNumber(current.phone_number)}
        </Body1>
      </div>
    )
  }

  const renderMailInformation = () => {
    if (!current.email || current.email === '') {
      return (
        <button type="button" className={classes.addInformationContainer} onClick={handleShowForm}>
          <AlternateEmailIcon className={classes.icon} />
          <Body1 fontColor={theme.palette.primary.main}>ajouter une adresse email</Body1>
        </button>
      )
    }
    return (
      <div className={classes.informationContainer}>
        <AlternateEmailIcon className={classes.icon} />
        <Body1 fontColor={theme.palette.secondary.dark}>{current.email}</Body1>
      </div>
    )
  }

  return (
    <div className={classes.container}>
      <div className={classes.name}>
        <Header1 lowerCase>{getApplicantName()}</Header1>
        {(!current.first_name || current.first_name === '') && (
          <button type="button" className={classes.addInformation} onClick={handleShowForm}>
            <Body1 fontColor={theme.palette.primary.main}>ajouter un prénom et nom</Body1>
          </button>
        )}
      </div>
      <div>
        {renderPhoneInformation()}
        {renderMailInformation()}
      </div>
    </div>
  )
}

export default ApplicantInformation
